// extracted by mini-css-extract-plugin
export var additionalFeatures = "index-module--additionalFeatures--1dhUw";
export var additionalFeaturesHeading = "index-module--additionalFeaturesHeading--1YTuR";
export var attrContainer = "index-module--attrContainer---em0J";
export var carousalImageContainer = "index-module--carousalImageContainer--Mg3Ds";
export var collapser = "index-module--collapser--nFRGh";
export var collapsible = "index-module--collapsible--4rfvL";
export var comparisonAttr = "index-module--comparisonAttr--qdOEb";
export var comparisonHeaders = "index-module--comparisonHeaders--Pj2pv";
export var comparisonRow = "index-module--comparisonRow--bga9T";
export var comparisons = "index-module--comparisons--tSoY0";
export var container = "index-module--container--+8w5S";
export var downCaret = "index-module--downCaret--82HLE";
export var expanded = "index-module--expanded--YYWNY";
export var externalLink = "index-module--externalLink--klM31";
export var externalLinks = "index-module--externalLinks--Z2e3g";
export var featurelist = "index-module--featurelist--ASXP-";
export var label = "index-module--label--Ug2hl";
export var measurementImage = "index-module--measurementImage--1Nkk2";
export var measurements = "index-module--measurements--szcv4";
export var mobileMeasurementsImageContainer = "index-module--mobileMeasurementsImageContainer--EaLZp";
export var mobileVariantName = "index-module--mobileVariantName--0edtK";
export var mobileVariantValue = "index-module--mobileVariantValue--19eNm";
export var set = "index-module--set--7HZ5T";
export var spec = "index-module--spec--Uy37r";
export var specs = "index-module--specs--O9Opy";
export var subValue = "index-module--subValue--2VC-S";
export var title = "index-module--title--WwsEr";
export var value = "index-module--value--lb2hF";
export var variantValueRow = "index-module--variantValueRow--NEEzy";